import React                    from 'react';
import {connect}                from 'react-redux';
import { Link }                 from 'react-router-dom';
import { GetDisciplinasPerfil } from '../../../actions/tarefaAction';
import { SetError }             from '../../../actions/authenticActions';
import FlashCarregando          from '../../../container/FlashCarregando';
import FlashRetornoNulo         from '../../../container/FlashRetornoNulo';

class ProfessorDisciplina extends React.Component {

    constructor(props){
      super(props);
      this.state = {load:false}
    }   

    componentWillMount(){

        this.props.GetDisciplinasPerfil(this.props.session.id,"").then((response) =>{
           this.setState({load:true});
        }).catch((error) =>{
            this.props.SetError(500);
        });
    }

    renderListaDisciplinasTarefas(){

        const listDisciplinasDados = this.props.all_equipe_disciplina;
        const lar              = {width  : '5%'}
        const lar2             = {width : '20%'}


        if (listDisciplinasDados.length) {
            return listDisciplinasDados.map((elem,i)=>{
                return  <tr key={i}>
                    <td className="text-center">{elem.dis_pro_cod_disciplina}</td>
                    {/* <td className="text-left" style={lar2}>{this.props.checkList?elem.dis_nome: `${elem.cur_nome} - ${elem.tur_nome} - ${elem.dis_nome}`} </td> */}
                    <td className="text-left" style={lar2}>{`${elem.cur_nome} - ${elem.tur_nome} - ${elem.dis_nome}`} </td> 
                    {this.props.timeline?
                    <td className="text-center" style={lar}>
                        <div className="pull-center">
                            <Link to={`${this.props.menu.turma.professor.timeline_turma}/${elem.tur_id}`} className="btn btn-primary btn-xs">
                                <span className="glyphicon glyphicon-eye-open"></span>
                            </Link>
                        </div>
                    </td>
                    :""}
                    <td className="text-center" style={lar}>
                        <div className="pull-center">
                            <Link to={`${this.props.menuParametro}/${elem.tur_id}/${elem.dis_pro_cod_disciplina}`} className="btn btn-primary btn-xs">
                                <span className="glyphicon glyphicon-share-alt"></span>
                            </Link>
                        </div>
                    </td>
                </tr>;
            });

        }else{
            return <tr> <td colSpan={6} className="text-center"><FlashRetornoNulo/></td></tr>;
        }
    }

    render() {
        
        const width = {width:'5%'}
        return (<div className="container-bg">
                    {!this.state.load ? <FlashCarregando/> :                     
                        <div className="panel panel-azul-claro panel-cinza">
                            <div className="panel-body table-responsive">
                                <table className="table table_panel">
                                    <thead>
                                      <tr>
                                        <th className="text-center" style={width}>#</th>
                                        <th className="text-left">Unidade Curricular</th>
                                        {this.props.timeline?<th className="text-center">Ver Turma</th>:""}
                                        <th className="text-center">{this.props.timeline?'Gerenciar Equipes':'Gerenciar Missões'}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {this.renderListaDisciplinasTarefas()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
                );
    }
}

function mapStateToProps(state){

    return {
            session : state.auth.session, 
            all_equipe_disciplina : state.tarefaReducer.all_disciplinas_tarefas, 
            menu    : state.configReducer.menu
           }
}

export default connect(mapStateToProps,{
                                         GetDisciplinasPerfil,
                                         SetError
                                        })(ProfessorDisciplina); 



// WEBPACK FOOTER //
// ./src/components/professor/disciplina/professor_disciplina.js